import { ReactNode } from "react";
import styled, { css } from "styled-components";

interface RowProps {
  children: ReactNode;
  breakOnMobile?: boolean;
}

interface ContentProps {
  breakOnMobile: boolean;
}

export function Row({ children, breakOnMobile = true }: RowProps) {
  return (
    <Content breakOnMobile={breakOnMobile}>
      { children }
    </Content>
  )
}

const Content = styled.div<ContentProps>`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    ${({ breakOnMobile }) => breakOnMobile && css`display: block;`};
  }
`;